import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import { ContentfulRichText } from 'common/components';
import './hero-title.less';

const HeroTitle = ({ text, color }) => {
  const className = useClassName('HeroTitle');

  return (
    <div className={className('container')}>
      <ContentfulRichText
        className={className('text')}
        style={{ color }}
        field={text}
      />
    </div>
  );
};

HeroTitle.propTypes = {
  text: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
};

export default HeroTitle;
